// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getResponsibilityOfDelayReasons(projectId: string, filter: string): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/delay_responsibility${filter === 'days' ? '?delay=true' : ''}`);
}
